import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import Label from 'components/form/Label/Label';
import { Row } from 'components/Containers/Row/Row';
import OfferCarouselContainer from 'partial/OfferManager/OfferCarouselContainer';
import { Image } from 'components/Image/Image';
import './BalanceTransferOcfModule.scss';

const BalanceTransferOcfModuleView = props => {
  return (
    <SectionContainer className={'balanceTransferOcfContainer margT8'}>
      <FlexContainer
        className={'headerContainer padLR48 m-padL16 m-padR22 justify-between'}
      >
        <FlexContainer className={'titleSection flex-column'}>
          <Label className={'H4 m-H4'}>
            {'Have you heard the news that interest rates are on the rise?'}
          </Label>
          <Label className={'Body-1 margT8 mBody-2 margT16'}>
            {
              'More interest rate hikes may be coming which means that your credit card APRs and monthly payments could increase as well.'
            }
          </Label>
          <Label className={'Body-1 margT8 mBody-2 margT32 m-margT20'}>
            <span
              dangerouslySetInnerHTML={{
                __html:
                  '<b>Our tip:</b> Some credit cards offer a 0% introductory interest rate for new balance transfers. By consolidating your credit card debt under one card with a lower rate, you can start saving on interest and put more money towards paying down your balance.',
              }}
            />
          </Label>
        </FlexContainer>
        <FlexContainer className={'m-hide'}>
          <Image imgClass={'balanceTransferImage bgImageW254'} />
        </FlexContainer>
      </FlexContainer>

      <Row type="carousel margT32 m-margT16">
        <OfferCarouselContainer
          {...props}
          offers={props.balanceTransferOffers}
          pagePosition={props.moduleName}
          modulePosition={props.modulePosition}
          containerType="SUGGESTED_BALANCE_TRANSFER_CARDS"
        />
      </Row>
    </SectionContainer>
  );
};

export default BalanceTransferOcfModuleView;
